import { useState } from "react";
import SpinnerLoader from "../../../../components/loader/spinner-loader";
import InputField from "../../../../components/form/input-field";
import ToggleSwitch from "../../../../components/form/toggle-switch";
import DatePickerField from "../../../../components/form/date-picker";
import ApiSupport from "../../../../lib/api-support";
import { ErrorFlash, SuccessFlash } from "../../../../components/helper/flash-notification";

const AddNotificationChannel = () => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);

    const [name, setName] = useState<string>('');
    const [nameError, setNameError] = useState<string | null>(null);

    const [noVirtualAccount, setNoVirtualAccount] = useState<boolean>(false);
    const [dormantAccount, setDormantAccount] = useState<boolean>(false);
    const [notVerified, setNotVerified] = useState<boolean>(false);
    const [phoneNumberNotVerified, setPhoneNumberNotVerified] = useState<boolean>(false);
    const [emailNotVerified, setEmailNotVerified] = useState<boolean>(false);
    const [registrationPeriod, setRegistrationPeriod] = useState<boolean>(false);

    const [registrationPeriodDate, setRegistrationPeriodDate] = useState<any>(null);

    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!name) {
            setNameError('Channel name is required');
            return;
        }
        setLoading(true);

        const date = registrationPeriodDate?.split('to')

        const request = await new ApiSupport().post(`pushNotification/createChannel`, {
            name,
            noVirtualAccount,
            dormantAccount,
            notVerified,
            phoneNumberNotVerified,
            emailNotVerified,
            registrationPeriod,
            registrationFrom: date?.[0] || null,
            registrationTo: date?.[1] || null,
        });
        setLoading(false);
        if (request === 'error') {
            ErrorFlash('Error processing request, try again.');
            return;
        }
        setName('');
        setNoVirtualAccount(false);
        setDormantAccount(false);
        setNotVerified(false);
        setRegistrationPeriod(false);
        setRegistrationPeriodDate(null);

        SuccessFlash('Notification sent successfully.');
        setShowModal(false);
    }
    

    return (
        <div className="relative">
            <button onClick={() => setShowModal(true)} className="flex items-center space-x-2 rounded-md text-primary border-primary hover:bg-opacity-90 input w-fit">
                <span>Add New Topic</span>
            </button>
            {(
                <div>
                    <div className={`${showModal ? 'flex' : 'hidden'} overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full`}>
                        <div className="relative w-full max-w-lg max-h-full p-4">
                            <div className="relative bg-white rounded-lg shadow">
                                <form onSubmit={submitForm} className="p-4 text-center md:p-5">
                                    <h3 className="my-5 mb-5 text-lg font-normal text-tertiary">
                                        Add New Topic
                                    </h3>
                                    <div className="grid gap-4 mb-5 text-left">
                                        <InputField
                                            label="Topic Name"
                                            onChangeInput={(e) => [setName(e.target.value), setNameError(null)]}
                                            error={nameError}
                                            placeholder="Enter topic name"
                                            value={name}
                                        />
                                        <p>Select Criteria</p>
                                        <div className="flex items-center space-x-2">
                                            <ToggleSwitch  
                                                initialState={noVirtualAccount}
                                                onToggle={setNoVirtualAccount}
                                            />
                                            <span className="label">No virtual account</span>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <ToggleSwitch 
                                                initialState={dormantAccount}
                                                onToggle={setDormantAccount}
                                            />
                                            <span className="label">Dormant account</span>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <ToggleSwitch 
                                                initialState={notVerified}
                                                onToggle={setNotVerified}
                                            />
                                            <span className="label">BVN not verified</span>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <ToggleSwitch
                                                initialState={emailNotVerified}
                                                onToggle={setEmailNotVerified}
                                            />
                                            <span className="label">Email not verified</span>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <ToggleSwitch
                                                initialState={phoneNumberNotVerified}
                                                onToggle={setPhoneNumberNotVerified}
                                            />
                                            <span className="label">Phone number not verified</span>
                                        </div>
                                        <div className="flex items-center space-x-2">
                                            <ToggleSwitch 
                                                initialState={registrationPeriod}
                                                onToggle={setRegistrationPeriod}
                                            />
                                            <span className="label">Registration period</span>
                                        </div>
                                        {registrationPeriod && <DatePickerField value={registrationPeriodDate} onChangeInput={setRegistrationPeriodDate} mode="range" inputClass="w-full" />}
                                    </div>
                                    <button disabled={loading} type="submit" className="text-white space-x-2 bg-primary hover:bg-tertiary focus:ring-4 focus:outline-none  font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center">
                                        <span>Submit</span>
                                        {loading && <SpinnerLoader />}
                                    </button>
                                    <button disabled={loading} onClick={() => setShowModal(!showModal)} type="button" className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 ">
                                        Cancel
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className={`fixed inset-0 z-40 bg-gray-900/50 ${showModal ? '' : 'hidden'}`}></div>
                </div>
            )}
        </div>
    );
}

export default AddNotificationChannel;